export default {"src":"https://static.spiritory.com/_next/static/media/4.4ce2a864.svg","height":70,"width":70,"blurWidth":0,"blurHeight":0};